import { render } from "./childLayout.vue?vue&type=template&id=9e664b3e"
import script from "./childLayout.vue?vue&type=script&lang=js"
export * from "./childLayout.vue?vue&type=script&lang=js"

import "./childLayout.vue?vue&type=style&index=0&id=9e664b3e&lang=less"

import exportComponent from "/home/runner/work/suplasercut-admin/suplasercut-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__